import { getServiceFee } from 'data/service/serviceSelectors'
import T from 'T'
import { get } from 'utils/lodash'
import { formatDollarsToCents, roundToScale } from 'utils/price'
import { getPriceType, getTaxList, isPriceTypeDollar, transformMultiplePricedServicesToSingle } from 'utils/service'

export const getTaxesAndFees = data => {
  const pricedServiceId = get(data, 'id')
  const transformResponse = transformMultiplePricedServicesToSingle(data, pricedServiceId)
  const generalFee = getServiceFee('General Fee', get(transformResponse, 'generalFeeList', []))
  const disposalFee = getServiceFee('Disposal Fee', get(transformResponse, 'disposableFeeList', []))
  const allFees = generalFee.concat(disposalFee)

  const taxList = getTaxList(
    [],
    get(transformResponse, 'taxList', []),
    get(transformResponse, 'generalFeeList', []),
    get(transformResponse, 'disposableFeeList', [])
  )

  const allFeesAndTaxes = allFees.concat(taxList)

  return allFeesAndTaxes
}

export const getTaxes = serviceData => {
  const priceServiceDetail = get(serviceData, 'priceServiceDetail', {})
  const feeTaxList = getTaxesAndFees(priceServiceDetail)
  const taxZoneId = get(serviceData, 'taxZoneId', '')
  const serviceId = get(priceServiceDetail, 'id', '')
  return feeTaxList.filter(tax => tax.type === T.TAX && tax.taxZoneId === taxZoneId && tax.visible && tax.serviceId === serviceId)
}

const getTaxAmount = (isFixedTax, taxPrice, subtotal) => {
  if (subtotal === 0) {
    return 0
  }

  if (isFixedTax) {
    return taxPrice
  }

  const calculatedTaxAmount = subtotal * (taxPrice / 100)
  const roundedCalculatedTaxAmount = roundToScale(calculatedTaxAmount)
  return roundedCalculatedTaxAmount
}

export const getTaxesForMaterial = (taxes, subtotal) => {
  let totalTaxCents = 0
  const taxesForMaterial = taxes.map(tax => {
    const taxId = get(tax, 'feeTaxId')
    const taxName = get(tax, 'feeName', '')
    const taxPrice = get(tax, 'price', 0)
    const taxValueType = get(tax, 'taxValueType')
    const priceType = getPriceType(taxValueType)
    const isFixedTax = isPriceTypeDollar(taxValueType)
    const taxAmountDollars = getTaxAmount(isFixedTax, taxPrice, subtotal)
    const taxAmountCents = formatDollarsToCents(taxAmountDollars)
    const formattedTaxPrice = isFixedTax ? `${priceType}${taxPrice}` : `${taxPrice}${priceType}`
    totalTaxCents += taxAmountCents
    return { id: taxId, taxName, formattedTaxPrice, taxAmountCents }
  })
  return { taxesForMaterial, totalTaxCents }
}
